module.exports = __webpack_public_path__ + "img/reply-icon.16fe8c48.svg";